<h2 mat-dialog-title>Atribuir Usuário ao Processo Seletivo</h2>
<mat-dialog-content>
  <h3 class="row col-sm-12 warning">
    Aqui você pode atribuir, consultar e remover usuários relacionados a este
    <strong>Processo Seletivo</strong>.
    <span
      >Lembre-se de que o usuário atribuído poderá visualizar e gerenciar o
      processo seletivo.</span
    >
    <small style="display: block; text-align: center"
      >Se deseja definir um novo usuário, escolha abaixo:</small
    >
  </h3>

  <form [formGroup]="form" (submit)="submit()" autocomplete="off">
    <ng-container *ngIf="users && users.length > 0; else noUsers">
      <div class="row" style="margin-top: 10px">
        <mat-form-field appearance="outline">
          <mat-label>Usuários</mat-label>
          <mat-select formControlName="selectedUser" class="form-control">
            <mat-option *ngFor="let user of users" [value]="user.id">
              {{ user.firstname }} {{ user.lastname ? user.lastname : "" }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('selectedUser').errors?.required">
            Por favor escolha uma opção
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>
    <ng-template #noUsers>
      <span>Nenhum usuário disponível para ser Atribuído no momento</span>
    </ng-template>
  </form>

  <h3 style="margin-top: 10px">Lista de Usuários já atribuidos</h3>
  <table class="table">
    <thead>
      <tr>
        <th>Nome</th>
        <th>Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of assignedUsers">
        <td style="text-align: center">
          {{ user.firstname }} {{ user.lastname ? user.lastname : "" }}
        </td>
        <td style="text-align: center">
          <button mat-icon-button color="warn" (click)="removeUser(user.id)">
            <mat-icon>remove_circle</mat-icon> remover
          </button>
        </td>
      </tr>
      <tr *ngIf="assignedUsers.length == 0">
        <td colspan="2" style="text-align: center">
          Não foi encontrado nenhum outro usuário atribuido.
        </td>
      </tr>
    </tbody>
  </table>
</mat-dialog-content>
<!-- <mat-progress-bar *ngIf="!users" mode="indeterminate"></mat-progress-bar> -->
<mat-dialog-actions>
  <button color="accent" mat-button mat-dialog-close>Cancelar</button>
  <button
    class="custom-primary"
    color="primary"
    mat-raised-button
    type="submit"
    [disabled]="!form.valid"
    (click)="submit()"
  >
    Salvar
  </button>
</mat-dialog-actions>
